import { createSelector } from '@ngrx/store';

import * as fromReducers from '../reducers';

export const getCreditReportDetailsState = createSelector(fromReducers.getCreditReportState, (state: fromReducers.CreditReportState) => state.details);

export const getCreditReportSummaryState = createSelector(getCreditReportDetailsState, fromReducers.getCreditReportSummary);

export const getCreditReportReasonsState = createSelector(getCreditReportDetailsState, fromReducers.getCreditReportReasons);

export const getCreditReportSummarySearchState = createSelector(getCreditReportDetailsState, fromReducers.getCreditReportSummarySearch);

export const getCreditReportRequestFormState = createSelector(getCreditReportDetailsState, fromReducers.getCreditReportRequestForm);
